const GenericLike = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12.3371 25.5H7.85495C7.10261 25.5 6.49425 24.886 6.50004 24.1326L6.56198 15.9897C6.56769 15.2442 7.17266 14.6429 7.91698 14.6429H12.3371M12.3371 25.5H21.6626C22.2976 25.5 22.8475 25.0583 22.9853 24.4374L25.4672 14.7286C25.6552 13.8811 25.0113 13.0769 24.1444 13.0769H20.363C19.5092 13.0769 18.8386 12.5044 19.0041 11.6655L19.7034 8.12022C19.8689 7.28128 19.2279 6.5 18.3742 6.5H18.1078C17.6259 6.5 17.1803 6.75645 16.9374 7.17327L12.3371 14.6429M12.3371 25.5V14.6429"
      stroke="currentColor"
    />
  </svg>
);

export default GenericLike;
